import classNames from "classnames";
import React, { useState } from "react";
import styles from "./OptionsItem.module.scss";

function OptionsItem({
  title,
  resultText,
  onClick,
  disabled,
  result,
  resultCountLogic,
}) {
  const [optionActive, setOptionActive] = useState(false);

  const optionActiveHandler = () => {
    onClick(true);
    setOptionActive(true);

    // если ответ верный прибавляем recultCount
    if (result) {
      resultCountLogic(1);
    }
  };

  return (
    <button
      onClick={optionActiveHandler}
      className={classNames({
        [styles.optionsItem]: true,
        [styles.optionsItemTrue]: optionActive && result,
        [styles.optionsItemFalse]: optionActive && !result,
      })}
      disabled={disabled}
    >
      <span className={styles.title}>{title}</span>
      {optionActive ? <span className={styles.text}>{resultText}</span> : <></>}
    </button>
  );
}

export default OptionsItem;
